
import { useEffect } from "react";
import { motion } from "framer-motion";

export default function PrivacyPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow pt-24 pb-24">
        <div className="container mx-auto px-4 py-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold font-playfair mb-8">Privacy Policy</h1>
            <div className="prose max-w-none space-y-6 text-gray-700">
              <p className="text-sm text-gray-500">Last updated: {new Date().toLocaleDateString()}</p>
              <p>
                At Aarsa, we are committed to protecting your privacy. This Privacy Policy explains how
                we collect, use, and safeguard your personal information when you visit our website or
                make a purchase.
              </p>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Information We Collect</h2>
              <p>We collect information that you provide directly to us, including:</p>
              <ul className="list-disc list-inside space-y-2">
                <li>Name, email address, phone number, and shipping address</li>
                <li>Payment information (processed securely through our payment partners)</li>
                <li>Order history and preferences</li>
                <li>Communication preferences</li>
              </ul>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">How We Use Your Information</h2>
              <ul className="list-disc list-inside space-y-2">
                <li>To process and ful your orders</li>
                <li>To communicate with you about your orders and our products</li>
                <li>To improve our website and services</li>
                <li>To send you marketing communications (with your consent)</li>
                <li>To comply with legal obligations</li>
              </ul>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Data Security</h2>
              <p>
                We implement appropriate security measures to protect your personal information. However,
                no method of transmission over the internet is 100% secure, and we cannot guarantee absolute
                security.
              </p>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Your Rights</h2>
              <p>You have the right to:</p>
              <ul className="list-disc list-inside space-y-2">
                <li>Access your personal information</li>
                <li>Correct inaccurate information</li>
                <li>Request deletion of your information</li>
                <li>Opt-out of marketing communications</li>
              </ul>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Contact Us</h2>
              <p>
                If you have questions about this Privacy Policy, please contact us at{" "}
                <a href="mailto:privacy@aarsa.com" className="text-aarsa-sage-600 hover:underline">
                  privacy@aarsa.com
                </a>
              </p>
            </div>
          </motion.div>
        </div>
      </main>
    </div>
  );
}
